<template>
    <div>
        <footer class="page-footer">
            <div class="page-footer__inner">
                <ul class="page-footer__list">
                    <li v-for="item in filteredMenu"
                        :key="item.id"
                        @click="setActive(item)"
                        :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link
                            v-if="item.available != 0 && !item.countryExclusion.includes(currentCountry)"
                            :to="{
                name: 'ProductType',
                params: { id: item.type, name: helpers.portal_name },
              }"
                        >{{ $t('menu.id' + item.id) }}
                        </router-link
                        >
                    </li>
                </ul>

                <ul class="page-footer__list page-footer__list--utility">
                    <li :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/contact">{{ $t('contactus') }}</router-link>
                    </li>
                    <li :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/faq">{{ $t('faq') }}</router-link>
                    </li>
                    <li :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/terms">{{ $t('terms') }}</router-link>
                    </li>
                    <li :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/privacy">{{ $t('privacy') }}</router-link>
                    </li>
                    <li :class="[currentLanguage == 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/cookies-policy">{{ $t('cookiespolicy') }}</router-link>
                    </li>
                    <li v-if="currentCountry=='AT'">
                        <router-link to="/terms-of-use">{{ $t('termsofuse') }}</router-link>
                    </li>
                    <li v-if="currentCountry=='AT' || (currentCountry=='CH' && ['Appiland', 'Fitlandclub'].includes(helpers.portal_name)) || (currentCountry == 'DE' && helpers.portal_name == 'Fitlandclub')">
                        <router-link to="/impressum">{{ $t('impressum') }}</router-link>
                    </li>
                    <li v-if="showUnsubscribeLink(currentCountry, helpers.portal_name)"
                        :class="[currentLanguage === 'AR' ? 'rtlTextWithoutAlign': '']">
                        <router-link to="/unsubscription">{{
                                $t('unsubscription')
                            }}
                        </router-link>
                    </li>
                </ul>

                <div v-if="helpers.portal_name === 'Gamistream' && currentCountry === 'RO'"
                     class="custom-svg">
                    <img width="100" style="margin-top: 30px"
                         v-if="helpers.portal_name === 'Gamistream' && currentCountry === 'RO'"
                         src="../assets/images/netopia.svg"
                         alt="Netopia"
                         class="custom-svg"
                    />
                    <p class="copyright">
                        TELFEED BV, Bos en Lommerplein 280, 1055 RW, Amsterdam, Netherlands.
                        Registration number: 77057996.
                    </p>
                </div>
                <p class="copyright">Copyright @ {{ currentYear }}</p>
            </div>
        </footer>
    </div>
</template>

<script>
import { helpers } from '../helper/portal_config';
import { showUnsubscribeLink } from '../helper/utils';
import EventBus from '../helper/event_bus';

export default {
    name: 'Footer',
    props: ['color'],
    data() {
        return {
            helpers: '',
            menu: [],
            currentLanguage: '',
            currentCountry: ''
        };
    },
    computed: {
        filteredMenu() {
            if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Runsio') {
                return this.menu.filter((_, index) => index !== 2 && index !== 3);
            }
            if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Fitlandclub') {
                return this.menu.filter((_, index) => index !== 2);
            }
            return this.menu;
        },
        currentYear() {
          return new Date().getFullYear();
        }
    },
    methods: {
        showUnsubscribeLink,
        setActive(item) {
            // start a bus to menu
            EventBus.$emit('SET_MENU_ACTIVE', item);
        },
        setCurrentCountry() {
            const {host} = window.location;
            this.currentCountry = host.split('.')[0].slice(0, 2)
                .toUpperCase();
        },
        setCurrentLanguage() {
            var lang = '';
            const {host} = window.location;
            var country = host.split('.')[0].slice(0, 2)
                .toUpperCase();
            if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
                lang = helpers.countryDefaultLanguage[country].toUpperCase();
            } else {
                lang = country.toUpperCase();
            }
            this.currentLanguage = lang;
        },
    },
    created() {
        this.helpers = helpers;
        this.menu = helpers.menu;

        this.setCurrentLanguage();
        this.setCurrentCountry();
    },
};
</script>
